import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import question from "assets/question.svg";
import { colors } from "constants/colors";
import React from "react";

const CommonQ = () => {
  const Accordion = styled((props) => {
    return <MuiAccordion disableGutters elevation={0} square {...props} />;
  })(({ theme }) => ({
    marginBottom: 24,
    borderRadius: 24,
    backgroundColor: "#F5F5F5",
    "&:before": {
      display: "none",
    },
  }));
  return (
    <div className="flex justify-center w-full px-8 py-[120px] md:py-[60px]">
      <div className="max-w-[1268px] flex items-center flex-col relative">
        <p className="text-amber-600 text-[40px] font-bold flex text-center justify-center mb-8 md:text-2xl">
          Түгээмэл асуулт <br className="hidden md:block" />
          хариулт
        </p>

        <p className="text-center mb-[68px] max-w-[650px] md:mb-[56px]">
          Хэрвээ таны хайсан асуулт энд байхгүй бол манай харилцагчийн
          үйлчилгээний 7755 2211 дугаарт хандан лавлана уу. Таны асуултад
          хариулахдаа бид үргэлж таатай байх болно
        </p>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="warning" fontSize="large" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <p className="text-lg text-black70 my-4 ml-8 text-start font-bold">
              Тохирол хэзээ явагдах вэ?
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                borderTop: 1,
                borderColor: "#FF5D35",
                opacity: 0.2,
                marginX: 4,
              }}
            />
            <Typography
              sx={{
                fontSize: 14,
                marginX: 4,
                paddingTop: 4,
                color: colors.black55,
              }}
            >
              “Megaball” лотерейн тохирол нь долоо хоног бүрийн Лхагва, Ням
              гарагт 17 цаг 50 минутаас тогтмол орон даяар Сүлд телевизээр болон
              “Megaball” фэйсбүүк хуудсаар шууд дамжуулагдан олон нийтэд хүрдэг.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="warning" fontSize="large" />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <p className="text-lg text-black70 my-4 ml-8 text-start font-bold">
              Манай тохиролыг хаанаас үзэх вэ?
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                borderTop: 1,
                borderColor: "#FF5D35",
                opacity: 0.2,
                marginX: 4,
              }}
            />
            <Typography
              sx={{
                fontSize: 14,
                marginX: 4,
                paddingTop: 4,
                color: colors.black55,
              }}
            >
              “Megaball” лотерейн тохиролыг долоо хоног бүрийн Лхагва, Ням
              гарагийн 17 цаг 50 минутаас Сүлд телевизээр орон даяар шууд
              дамжуулдаг. Мөн манай “Megaball” фэйсбүүк хуудсаар хүлээн авч үзэх
              боломжтой.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className="w-full">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="warning" fontSize="large" />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <p className="text-lg text-black70 my-4 ml-8 text-start font-bold">
              Лотерейн тасалбар хаанаас худалдаж авах вэ
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                borderTop: 1,
                borderColor: "#FF5D35",
                opacity: 0.2,
                marginX: 4,
              }}
            />
            <p className={"text-sm w-full text-black55 pl-8  pt-4"}>
              Та гар утсандаа “Hipay” болон “Monpay” аппликейшн татаж авч,
              бүртгүүлээд “Megaball” лотерейн тасалбар худалдан авч оролцох
              боломжтой.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="warning" fontSize="large" />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <p className="text-lg text-black70 my-4 ml-8 text-start font-bold">
              Хонжвор хожсон тохиолдолд хэрхэн авах вэ?
            </p>
          </AccordionSummary>
          <AccordionDetails style={{ marginBottom: 12 }}>
            <Typography
              sx={{
                borderTop: 1,
                borderColor: "#FF5D35",
                opacity: 0.2,
                marginX: 4,
              }}
            />
            <Typography
              sx={{
                fontSize: 14,
                marginX: 4,
                paddingTop: 4,
                color: colors.black55,
              }}
            >
              Жекпот болон хоёр, гуравдугаар шагналын ялагч болсон тоглогч нь
              “Мегаболл” ХХК-ийн оффист өөрийн биеэр иргэний үнэмлэх болон бичиг
              баримттайгаа хүрэлцэн ирж, маягт бөглөн баталгаажуулснаар хонжвор
              хүлээн авах эрх үүснэ. Бусад хонжворууд таны “Hipay” болон
              “Monpay” хэтэвчинд 24 цагийн дотор шилжин орно.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="warning" fontSize="large" />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <p className="text-lg text-black70 my-4 ml-8 text-start font-bold">
              Мегаболл албан ёсны байдлыг хэн хангадаг вэ?
            </p>
          </AccordionSummary>
          <AccordionDetails style={{ marginBottom: 12 }}>
            <Typography
              sx={{
                borderTop: 1,
                borderColor: "#FF5D35",
                opacity: 0.2,
                marginX: 4,
              }}
            />
            <Typography
              sx={{
                fontSize: 14,
                marginX: 4,
                paddingTop: 4,
                color: colors.black55,
              }}
            >
              Megaball компани Америкийн Megamillions-н ашиглагддаг яг ижил
              тохирлын машиныг оруулж ирсэн бөгөөд санамсаргүй байдлын
              баталгаажуулалтыг олон улсын Gaming Labs International байгууллага
              хийдэг. Бид тухайн өдрийн тохирол эхлэхээс 20 минутын өмнө нийт
              борлуулагдсан тасалбарын лацтай тайланг хөндлөнгийн аудитын
              байгууллагад хүлээлгэн өгснөөр зөвхөн тухайн лацтай тайлангаас л
              азтан тодордог.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <img
          alt=""
          src={question}
          className="h-[104px] absolute top-0 right-0 md:h-[43px]"
        />
      </div>
    </div>
  );
};
export default CommonQ;
